import { apiService } from "./apiService";
import { endpoints } from "@/config/endpoints";
import { GmbMediaStorageType } from "@/enums/gmb-media-storage-type.js";
import { pickBy } from "lodash";

export default {
  getPosts({ page, perPage, query, date, showDeleted }) {
    const params = {
      page: page,
      page_size: perPage,
      q: query,
      date_from: date[0],
      date_to: date[1]
    };

    return apiService.get(endpoints.gmbPosts, {
      params: { ...pickBy(params), show_deleted: showDeleted }
    });
  },
  getPostsSchedule({ page, perPage, query, date }) {
    const params = {
      page: page,
      page_size: perPage,
      q: query,
      date_from: date[0],
      date_to: date[1]
    };

    return apiService.get(endpoints.gmbPostsSchedule, {
      params: pickBy(params)
    });
  },

  getScheduledPost(id) {
    return apiService.get(endpoints.gmbPostScheduled(id));
  },
  editScheduledPost(id, payload) {
    return apiService.put(endpoints.gmbPostScheduled(id), payload);
  },
  getPostsScheduleCalendar() {
    return apiService.get(endpoints.gmbPostsScheduleCalendar);
  },

  getPostFacilities({ postId, page, perPage, query, statuses }) {
    const params = {
      page: page,
      page_size: perPage,
      q: query,
      status: statuses.join(",")
    };

    return apiService.get(endpoints.gmbPostsFacilities(postId), {
      params: pickBy(params)
    });
  },

  getMediaFacilities({ mediaId, page, perPage, query, statuses }) {
    const params = {
      page: page,
      page_size: perPage,
      q: query,
      status: statuses.join(",")
    };

    return apiService.get(endpoints.gmbMediaFacilities(mediaId), {
      params: pickBy(params)
    });
  },

  postPost(form) {
    return apiService.post(endpoints.gmbPosts, form);
  },

  deletePost(postId) {
    return apiService.delete(endpoints.gmbPost(postId));
  },

  deleteScheduledPost(postId) {
    return apiService.delete(endpoints.gmbPostScheduled(postId));
  },

  getImageUrl(form) {
    form.append("type", GmbMediaStorageType.LOCAL_POST);
    return apiService.post(endpoints.gmbMediaStorage, form);
  },

  getPostsInsights(postIds) {
    return apiService.post(endpoints.gmbPostsInsights, {
      post_ids: postIds.join(",")
    });
  },

  setStoreLocatorVisibility(postId, visible) {
    if (visible) {
      return apiService.post(endpoints.gmbPostsStoreLocator(postId));
    } else {
      return apiService.delete(endpoints.gmbPostsStoreLocator(postId));
    }
  }
};
